
if( $('#page-news').length ){
	page_news();
}
if( $('#page-product').length && $('.wp-post_archive').length ){
	page_news();
}


function page_news(){
	// ページャーに span 追加
	$('a.page-numbers, span.page-numbers').each( function(){
		var val = $(this).html();
		$(this).html( '<span>'+val+'</span>' );
	});
}


//////////////////
// WEBPACK FOOTER
// ./js/page/news.js
// module id = 13
// module chunks = 0